import type { Person } from "../../lib/api-types";
import { formatRegion } from "../../lib/format";

export type LineupSong = { kind: "none" } | { kind: "song"; label: string; region: string };

/**
 * The song line for one lineup row, read from the person's current song fields. A person without
 * song media has no song, whatever label or region the row last showed.
 */
export function lineupSong(person: Person | undefined): LineupSong {
  if (!person?.songMediaId) return { kind: "none" };
  return {
    kind: "song",
    label: person.songLabel ?? "",
    region: formatRegion(person.startMs, person.lengthS),
  };
}
